import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/*
 * A small "value + uppercase label" tile (profile stats, hero stats). `tone`
 * colors the value for the gold/green accents the prototype uses.
 */
interface StatTileProps {
  value: ReactNode;
  label: string;
  tone?: 'default' | 'gold' | 'green' | 'orange';
  /** Boxed (panel-in) vs bare (hero) presentation. */
  boxed?: boolean;
  className?: string;
}

const TONE: Record<NonNullable<StatTileProps['tone']>, string> = {
  default: 'text-strong',
  gold: 'text-gold',
  green: 'text-green',
  orange: 'text-orange',
};

export function StatTile({
  value,
  label,
  tone = 'default',
  boxed = true,
  className,
}: StatTileProps) {
  return (
    <div className={cn(boxed && 'bevel bg-panel-in px-4 py-2.5', 'min-w-[86px]', className)}>
      <div className={cn('font-display text-lg', TONE[tone])}>{value}</div>
      <div className="text-faint text-[10px] uppercase tracking-wide">{label}</div>
    </div>
  );
}
